import doc                                      from '@widesk-core/decorators/doc';
import AbstractStonecodeMailEditorMailTypeModel from './AbstractStonecodeMailEditorMailTypeModel';

@doc.urnResource('stonecode_mail_editor_mail_type')
export default class StonecodeMailEditorMailTypeModel extends AbstractStonecodeMailEditorMailTypeModel {}
